import querystring from "querystring";
var SubAPI = /** @class */ (function () {
    function SubAPI(api) {
        this.api = void 0;
        this.api = api;
    }
    SubAPI.prototype.fetchPaginated = function (path, props) { if (props.download !== undefined) {
        window.location.href = path + "?" + querystring.stringify(props);
        return Promise.resolve({ data: [], totalCount: 0 });
    } return this.fetcher.get(path, props); };
    Object.defineProperty(SubAPI.prototype, "fetcher", {
        get: function () { return this.api.fetcher; },
        enumerable: false,
        configurable: true
    });
    return SubAPI;
}());
export { SubAPI };
